export const defaultThemes = [
  {
    name: "Default",
    value: "light",
    colors: {
      "--background": "0 0% 100%",
      "--foreground": "135 100% 4%",
      "--muted": "0 0% 96.21%",
      "--muted-foreground": "215.4 16.3% 46.9%",
      "--popover": "0 0% 100%",
      "--popover-foreground": "0 0% 38%",
      "--card": "0 0% 98%",
      "--card-foreground": "0 0% 38%",
      "--border": "214.3 31.8% 91.4%",
      "--input": "214.3 31.8% 91.4%",
      "--primary": "85 49% 58%",
      "--primary-foreground": "210 40% 98%",
      "--secondary": "112 60% 20%",
      "--secondary-foreground": "85 49% 58%",
      "--accent": "112 60% 20%",
      "--accent-foreground": "85 49% 58%",
      "--destructive": "0 84.2% 60.2%",
      "--destructive-foreground": "210 40% 98%",
      "--ring": "0 0% 38%",
      "--chart-1": "12 76% 61%",
      "--chart-2": "173 58% 39%",
      "--chart-3": "197 37% 24%",
      "--chart-4": "43 74% 66%",
      "--chart-5": "27 87% 67%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "Dark",
    value: "dark",
    colors: {
      "--background": "0 0% 38%",
      "--foreground": "210 40% 98%",
      "--muted": "217.2 32.6% 17.5%",
      "--muted-foreground": "215 20.2% 65.1%",
      "--popover": "0 0% 38%",
      "--popover-foreground": "210 40% 98%",
      "--card": "0 0% 40%",
      "--card-foreground": "210 40% 98%",
      "--border": "217.2 32.6% 17.5%",
      "--input": "217.2 32.6% 17.5%",
      "--primary": "85 79% 48%",
      "--primary-foreground": "85 49% 58%",
      "--secondary": "116 100% 97%",
      "--secondary-foreground": "210 40% 98%",
      "--accent": "217.2 32.6% 17.5%",
      "--accent-foreground": "210 40% 98%",
      "--destructive": "0 62.8% 30.6%",
      "--destructive-foreground": "210 40% 98%",
      "--ring": "212.7 26.8% 83.9%",
      "--chart-1": "220 70% 50%",
      "--chart-2": "160 60% 45%",
      "--chart-3": "30 80% 55%",
      "--chart-4": "280 65% 60%",
      "--chart-5": "340 75% 55%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "Vintage",
    value: "vintage",
    colors: {
      "--primary": "34 57% 50%",
      "--primary-foreground": "0 0% 100%",
      "--secondary": "20 30% 60%",
      "--secondary-foreground": "0 0% 100%",
      "--accent": "10 40% 50%",
      "--accent-foreground": "0 0% 100%",
      "--border": "30 20% 70%",
      "--background": "0 0% 95%",
      "--foreground": "0 0% 10%",
      "--card": "0 0% 90%",
      "--card-foreground": "0 0% 10%",
      "--popover": "0 0% 90%",
      "--popover-foreground": "0 0% 10%",
      "--muted": "0 0% 80%",
      "--muted-foreground": "0 0% 40%",
      "--destructive": "350 70% 50%",
      "--destructive-foreground": "0 0% 100%",
      "--ring": "34 57% 50%",
      "--input": "0 0% 85%",
      "--chart-1": "34 57% 50%",
      "--chart-2": "20 30% 60%",
      "--chart-3": "10 40% 50%",
      "--chart-4": "30 20% 70%",
      "--chart-5": "0 0% 95%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "One Dark Pro",
    value: "one-dark-pro",
    colors: {
      "--primary": "220 13% 18%",
      "--primary-foreground": "220 14% 96%",
      "--background": "220 13% 10%",
      "--foreground": "220 14% 96%",
      "--accent": "340 82% 52%",
      "--accent-foreground": "0 0% 100%",
      "--secondary": "200 10% 30%",
      "--secondary-foreground": "0 0% 100%",
      "--muted": "220 10% 30%",
      "--muted-foreground": "220 14% 70%",
      "--card": "220 13% 12%",
      "--card-foreground": "220 14% 96%",
      "--popover": "220 13% 10%",
      "--popover-foreground": "220 14% 96%",
      "--border": "220 10% 20%",
      "--input": "220 10% 20%",
      "--destructive": "0 80% 55%",
      "--destructive-foreground": "0 0% 100%",
      "--ring": "340 82% 52%",
      "--chart-1": "340 82% 52%",
      "--chart-2": "200 10% 40%",
      "--chart-3": "60 100% 50%",
      "--chart-4": "120 40% 40%",
      "--chart-5": "280 40% 50%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "Dracula Official",
    value: "dracula",
    colors: {
      "--primary": "225 25% 16%",
      "--primary-foreground": "231 15% 90%",
      "--background": "231 15% 12%",
      "--foreground": "231 15% 90%",
      "--accent": "330 100% 71%",
      "--accent-foreground": "231 15% 12%",
      "--secondary": "265 89% 78%",
      "--secondary-foreground": "0 0% 100%",
      "--muted": "231 15% 25%",
      "--muted-foreground": "231 15% 70%",
      "--card": "231 15% 14%",
      "--card-foreground": "231 15% 90%",
      "--popover": "231 15% 12%",
      "--popover-foreground": "231 15% 90%",
      "--border": "231 15% 20%",
      "--input": "231 15% 20%",
      "--destructive": "0 100%, 67%",
      "--destructive-foreground": "0, 0%, 100%",
      "--ring": "265, 89%, 78%",
      "--chart-1": "330, 100%, 71%",
      "--chart-2": "265, 89%, 78%",
      "--chart-3": "190, 100%, 70%",
      "--chart-4": "100, 100%, 75%",
      "--chart-5": "40, 100%, 80%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "Catppuccin Macchiato",
    value: "catppuccin-macchiato",
    colors: {
      "--primary": "230, 30%, 20%",
      "--primary-foreground": "230, 30%, 95%",
      "--background": "230, 30%, 10%",
      "--foreground": "230, 30%, 95%",
      "--accent": "265, 60%, 70%",
      "--accent-foreground": "0, 0%, 100%",
      "--secondary": "300, 30%, 60%",
      "--secondary-foreground": "0, 0%, 100%",
      "--muted": "230, 20%, 30%",
      "--muted-foreground": "230, 20%, 70%",
      "--card": "230, 30%, 12%",
      "--card-foreground": "230, 30%, 95%",
      "--popover": "230, 30%, 10%",
      "--popover-foreground": "230, 30%, 95%",
      "--border": "230, 20%, 20%",
      "--input": "230, 20%, 20%",
      "--destructive": "0, 80%, 60%",
      "--destructive-foreground": "0, 0%, 100%",
      "--ring": "265, 60%, 70%",
      "--chart-1": "265, 60%, 70%",
      "--chart-2": "300, 30%, 60%",
      "--chart-3": "200, 50%, 50%",
      "--chart-4": "180, 50%, 60%",
      "--chart-5": "100, 40%, 50%",
    },
  },
  {
    name: "Ayu Mirage",
    value: "ayu-mirage",
    colors: {
      // Couleurs principales sombres, avec un bon contraste pour le texte
      "--primary": "220 16% 22%",
      "--primary-foreground": "42 100% 80%",
      "--background": "220 16% 15%",
      "--foreground": "42 100% 85%",
      "--accent": "42 100% 70%", // jaune-orangé caractéristique
      "--accent-foreground": "220 16% 15%",
      "--secondary": "280 13% 35%",
      "--secondary-foreground": "0 0% 100%",
      "--muted": "220 12% 28%",
      "--muted-foreground": "220 12% 65%",
      "--card": "220 16% 18%",
      "--card-foreground": "42 100% 85%",
      "--popover": "220 16% 15%",
      "--popover-foreground": "42 100% 85%",
      "--border": "220 12% 25%",
      "--input": "220 12% 25%",
      "--destructive": "0 80% 60%",
      "--destructive-foreground": "0 0% 100%",
      "--ring": "42 100% 70%",
      "--chart-1": "42 100% 70%",
      "--chart-2": "195 70% 60%",
      "--chart-3": "330 60% 70%",
      "--chart-4": "120 40% 55%",
      "--chart-5": "280 40% 65%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "Tokyo Night",
    value: "tokyo-night",
    colors: {
      // Teinte bleutée dominante inspirée de la ville de Tokyo la nuit
      "--primary": "230 20% 18%",
      "--primary-foreground": "220 100% 85%",
      "--background": "230 20% 10%",
      "--foreground": "220 100% 85%",
      "--accent": "270 100% 75%", // violet vif
      "--accent-foreground": "230 20% 10%",
      "--secondary": "195 100% 75%", // cyan clair
      "--secondary-foreground": "0 0% 100%",
      "--muted": "230 15% 25%",
      "--muted-foreground": "220 14% 70%",
      "--card": "230 20% 12%",
      "--card-foreground": "220 100% 85%",
      "--popover": "230 20% 10%",
      "--popover-foreground": "220 100% 85%",
      "--border": "230 15% 22%",
      "--input": "230 15% 22%",
      "--destructive": "0 80% 60%",
      "--destructive-foreground": "0 0% 100%",
      "--ring": "270 100% 75%",
      "--chart-1": "270 100% 75%",
      "--chart-2": "195 100% 75%",
      "--chart-3": "45 100% 70%",
      "--chart-4": "120 60% 50%",
      "--chart-5": "330 60% 65%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "Monokai Pro",
    value: "monokai-pro",
    colors: {
      // Fidèle au thème classique Monokai mais avec une touche plus moderne
      "--primary": "240 10% 20%",
      "--primary-foreground": "60 100% 85%",
      "--background": "240 10% 12%",
      "--foreground": "60 100% 85%",
      "--accent": "325 100% 70%", // rose vibrant
      "--accent-foreground": "240 10% 12%",
      "--secondary": "280 100% 75%", // violet saturé
      "--secondary-foreground": "0 0% 100%",
      "--muted": "240 10% 25%",
      "--muted-foreground": "240 10% 65%",
      "--card": "240 10% 15%",
      "--card-foreground": "60 100% 85%",
      "--popover": "240 10% 12%",
      "--popover-foreground": "60 100% 85%",
      "--border": "240 10% 22%",
      "--input": "240 10% 22%",
      "--destructive": "0 80% 55%",
      "--destructive-foreground": "0 0% 100%",
      "--ring": "325 100% 70%",
      "--chart-1": "325 100% 70%",
      "--chart-2": "280 100% 75%",
      "--chart-3": "120 60% 60%",
      "--chart-4": "60 100% 65%",
      "--chart-5": "200 100% 70%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "Houston",
    value: "houston",
    colors: {
      // Bleu spatial et menthe froide
      "--primary": "205 60% 20%",
      "--primary-foreground": "160 100% 80%",
      "--background": "210 60% 10%",
      "--foreground": "160 100% 85%",
      "--accent": "160 100% 70%",
      "--accent-foreground": "205 60% 10%",
      "--secondary": "200 40% 45%",
      "--secondary-foreground": "0 0% 100%",
      "--muted": "205 30% 25%",
      "--muted-foreground": "160 20% 70%",
      "--card": "205 60% 13%",
      "--card-foreground": "160 100% 85%",
      "--popover": "210 60% 10%",
      "--popover-foreground": "160 100% 85%",
      "--border": "205 30% 28%",
      "--input": "205 30% 28%",
      "--destructive": "0 70% 60%",
      "--destructive-foreground": "0 0% 100%",
      "--ring": "160 100% 70%",
      "--chart-1": "160 100% 70%",
      "--chart-2": "200 60% 65%",
      "--chart-3": "280 40% 70%",
      "--chart-4": "100 60% 60%",
      "--chart-5": "40 90% 60%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "Aofuji Light",
    value: "aofuji-light",
    colors: {
      // Teinte claire bleutée très douce
      "--primary": "230 60% 95%",
      "--primary-foreground": "230 80% 25%",
      "--background": "0 0% 100%",
      "--foreground": "230 60% 25%",
      "--accent": "230 80% 60%",
      "--accent-foreground": "0 0% 100%",
      "--secondary": "220 30% 85%",
      "--secondary-foreground": "230 80% 25%",
      "--muted": "220 30% 90%",
      "--muted-foreground": "220 15% 50%",
      "--card": "210 100% 98.5%",
      "--card-foreground": "230 60% 25%",
      "--popover": "230 100% 98%",
      "--popover-foreground": "230 80% 25%",
      "--border": "220 30% 85%",
      "--input": "220 30% 85%",
      "--destructive": "0 70% 60%",
      "--destructive-foreground": "0 0% 100%",
      "--ring": "230 80% 60%",
      "--chart-1": "230 80% 60%",
      "--chart-2": "180 70% 60%",
      "--chart-3": "330 70% 65%",
      "--chart-4": "45 90% 65%",
      "--chart-5": "270 60% 60%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "NotFlask Dark",
    value: "notflask-dark",
    colors: {
      // Look sombre moderne
      "--primary": "220 15% 18%",
      "--primary-foreground": "210 100% 90%",
      "--background": "220 15% 12%",
      "--foreground": "210 100% 90%",
      "--accent": "280 90% 70%",
      "--accent-foreground": "220 15% 12%",
      "--secondary": "200 70% 70%",
      "--secondary-foreground": "0 0% 100%",
      "--muted": "220 10% 30%",
      "--muted-foreground": "210 10% 65%",
      "--card": "220 15% 14%",
      "--card-foreground": "210 100% 90%",
      "--popover": "220 15% 12%",
      "--popover-foreground": "210 100% 90%",
      "--border": "220 10% 25%",
      "--input": "220 10% 25%",
      "--destructive": "0 80% 55%",
      "--destructive-foreground": "0 0% 100%",
      "--ring": "280 90% 70%",
      "--chart-1": "280 90% 70%",
      "--chart-2": "200 70% 70%",
      "--chart-3": "100 60% 60%",
      "--chart-4": "40 90% 65%",
      "--chart-5": "320 60% 60%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "NotFlask Light",
    value: "notflask-light",
    colors: {
      // Variante claire du thème NotFlask
      "--primary": "210 50% 95%",
      "--primary-foreground": "220 100% 30%",
      "--background": "0 0% 100%",
      "--foreground": "210 50% 25%",
      "--accent": "280 90% 60%",
      "--accent-foreground": "0 0% 100%",
      "--secondary": "200 80% 75%",
      "--secondary-foreground": "210 50% 25%",
      "--muted": "210 40% 90%",
      "--muted-foreground": "210 30% 50%",
      "--card": "210 100% 98.5%",
      "--card-foreground": "210 50% 25%",
      "--popover": "210 100% 98%",
      "--popover-foreground": "220 100% 30%",
      "--border": "210 40% 85%",
      "--input": "210 40% 85%",
      "--destructive": "0 70% 60%",
      "--destructive-foreground": "0 0% 100%",
      "--ring": "280 90% 60%",
      "--chart-1": "280 90% 60%",
      "--chart-2": "200 80% 70%",
      "--chart-3": "100 60% 60%",
      "--chart-4": "45 90% 65%",
      "--chart-5": "320 60% 65%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
  {
    name: "Valorant Based",
    value: "valorant",
    colors: {
      // Inspiré du jeu : rouge noir gris vert militaire
      "--primary": "0 100% 35%",
      "--primary-foreground": "0 0% 100%",
      "--background": "230 10% 8%",
      "--foreground": "0 0% 95%",
      "--accent": "160 60% 45%", // vert armée
      "--accent-foreground": "230 10% 8%",
      "--secondary": "0 0% 40%", // gris foncé
      "--secondary-foreground": "0 0% 100%",
      "--muted": "230 10% 15%",
      "--muted-foreground": "0 0% 60%",
      "--card": "230 10% 10%",
      "--card-foreground": "0 0% 95%",
      "--popover": "230 10% 8%",
      "--popover-foreground": "0 0% 95%",
      "--border": "230 10% 20%",
      "--input": "230 10% 20%",
      "--destructive": "0 80% 60%",
      "--destructive-foreground": "0 0% 100%",
      "--ring": "160 60% 45%",
      "--chart-1": "0 100% 35%",
      "--chart-2": "160 60% 45%",
      "--chart-3": "0 0% 60%",
      "--chart-4": "45 100% 60%",
      "--chart-5": "280 70% 65%",
      "--color-red": "0 84% 60%",
      "--color-blue": "193 48% 56%",
      "--color-gray": "130 26% 72%",
      "--color-green": "148 79% 38%",
      "--color-orange": "84 56% 45%",
    },
  },
];
